import { ResponseSpiffRecord } from '../../store/Spiff';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const getSpiffItems = (entityType: string, entityId: string) => {
  return apiService.callExternalApi<ResponseSpiffRecord>({
    url: `${API_SERVER_URL}/attribution/${entityType}/${entityId}/spiffs`,
    method: 'get'
  });
};
